import{t as r}from"./toConsumableArray-25e5c43c.js";var o=function(o){var i=o.sort,t=o.pagination,a=o.tree;return function(o){var e=r(o);return e=i?i.modifier(e):e,e=t?t.modifier(e):e,e=a?a.modifier(e):e}};export{o as a};
//# sourceMappingURL=modifiers-d418f2b2.js.map
